import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initializeAPI } from './config/api';

/**
 * True when this window is the Microsoft popup carrying the login reply.
 * Mounting the router would replace "/" with "/login" and wipe the hash MSAL still needs.
 */
function isMicrosoftPopupCallback() {
  if (!window.opener) {
    return false;
  }
  const payload = `${window.location.hash}&${window.location.search}`;
  return /(?:code|error|id_token|state|client_info)=/.test(payload);
}

if (isMicrosoftPopupCallback()) {
  // Leave the hash untouched for the opener.
} else {
initializeAPI().then(() => {
  console.log('✅ API configurada, renderizando aplicação...');
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}).catch(error => {
  console.error('❌ Erro ao configurar API:', error);
  // Renderizar mesmo com erro
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
}
